/* eslint-disable max-len */
/**
 * English translations.
 */
export default {
  ACTION: {
    CANCEL: 'Cancel',
    CONFIRM: 'Confirm',
    CONFIRM_POLL_RESPONSE: 'Confirm response',
    CONTINUE: 'Continue',
    COPY: 'Copy',
    DELETE: 'Delete',
    DELETE_MESSAGE: 'Delete message',
    EDIT: 'Edit',
    FINISH: 'Finish',
    HIDE_ANSWERS: 'Hide answers',
    LETS_GET_STARTED: 'Sure, let\'s get started',
    MARK_AS_UNREAD: 'Mark as unread',
    REPLY: 'Reply',
    SEE_ANSWERS: 'See answers',
    START_SURVEY: 'Start survey'
  },
  ERROR: {
    ASSET_SIZE_EXCEEDED: 'The maximum size of a file is {size}MB',
    CLASSIFICATION_ALREADY_IN_USE:
      'The survey expired because there is already a campaign for this category.',
    ERROR_CREATING_NEW_SUGGESTION: 'Error creating new offer',
    ERROR_SAVING_PRODUCT_REVIEW: 'Error saving product review',
    ERROR_SENDING_MESSAGE: 'Error sending message',
    ERROR_SUBMITTING_SURVEY: 'Error submitting survey',
    IMAGE_SIZE_EXCEEDED: 'The maximum size of an image is {size}MB',
    MESSAGE_ALREADY_READ:
      'This message can no longer be edited because it has already been read.',
    UPLOADED_ASSETS_EXCEED: 'The maximum number of files is {limit}',
    VIDEO_SIZE_EXCEEDED: 'The maximum size of a video is {size}MB'
  },
  HEADER: {},
  LABEL: {
    ACTIONS: 'Actions',
    ADDITIONAL_COMMENTS_QUESTION: 'Additional comments?',
    ANSWERED_ON: 'Answered on {date}',
    CONTACT_OWNER: 'Something went wrong. Please contact your owner',
    CREATE_NEW_CAMPAIGN_SUGGESTION: 'Click here to generate a new offer',
    EDITED: 'Edited',
    EXPIRED_ON: 'Expired on {date}',
    LAST_READ: 'Last read',
    POLL_CAMPAIGN_EXPIRED: 'ℹ️ Expired offer',
    POLL_CAMPAIGN_FOOTER:
      'ℹ️ By accepting, the campaign will be created and will start tomorrow.\nYou will also receive tomorrow the message with the poster to share.\nThis offer will be available for 3 days.',
    QUANTITY: 'Quantity',
    REACT: 'React',
    REACTIONS: 'Reactions',
    RESPOND_BY: 'Respond by {date}',
    SEE_PRODUCTS: 'See products',
    SEEN: 'Seen',
    SELECT_ADDRESS: 'Sellect address',
    SELECT_ONE_OPTION: 'Select an option',
    SELECT_ONE_OR_MORE_OPTION: 'Select one or more options',
    SENT: 'Sent',
    SWIPE_TO_CANCEL: 'Swipe to cancel',
    TYPE_NEW_MESSAGE: 'Type a new message',
    VOICE_MESSAGE: 'Voice message'
  },
  SENTENCE: {
    CONFIRM_POLL_INTERNAL_ORDER:
      'This action will confirm the order and it will not be possible to change the response. Are you sure you want to continue?',
    DELETE_MESSAGE_CONFIRM: 'Are you sure you want to delete this message?',
    GIVE_OPINION_ABOUT_PRODUCT: 'Can you give us your opinion on this product?',
    MESSAGE_DELETED: 'This message was deleted'
  },
  SUCCESS: {},
  TOOLTIP: {}
};
